import React from 'react';
import { makeStyles } from '@material-ui/core';
import QuestionText from '../atoms/Text/QuestionText';

const Question = (props) => {
    const classes = useStyles();

    return(
        <div className={classes.root}>
            <QuestionText text={props.text} />
        </div>
    );
};

const useStyles = makeStyles({
    root: {
        // border: '1px solid blue',
    },
});

export default Question;